import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "fl mr5" }, "利用する質問を設定", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "mt20"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "fs13 fw600 fl mr5 ml5" }, "AIが利用する質問項目:", -1)
const _hoisted_6 = {
  key: 0,
  class: "mr10 fl with_white_bg padw5 rad3 mb5"
}
const _hoisted_7 = { class: "fs14 fw600 fl mt3 mr5" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = { class: "pad15 pointer" }
const _hoisted_12 = {
  class: /*#__PURE__*/_normalizeClass(`dgrey fl posRe fw600 mr10 mt5`),
  style: {}
}
const _hoisted_13 = {
  class: "kireiOrangeBg fl rad10 whiteColor pad5 fs16 mt5 mr10",
  style: {"width":"30px","height":"30px"}
}
const _hoisted_14 = {
  key: 0,
  class: "fl"
}
const _hoisted_15 = { class: "fl mt13 fs14 fw600" }
const _hoisted_16 = {
  key: 1,
  class: "fl"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt13 fs14 fw600" }, "共有外の調整カレンダー", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt3 mb1 fs13",
  style: {}
}, "交換", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt4 mb1 fs13",
  style: {}
}, "入力例から選択", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = ["src", "onClick"]
const _hoisted_29 = { class: "fr fs11" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600" }, "AIが選ぶ調整カレンダーを追加", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600 mb10" }, "選択可能な調整カレンダーは最大5つまでです。", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600 mb10" }, [
  /*#__PURE__*/_createTextVNode(" 共有されているユーザーは、調整カレンダーの追加・交換はできません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("オーナーに依頼してください。 ")
], -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!

  return (_ctx.Util.isPresent(_ctx.availableScheduleRules))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "fl pointer centered circle_button fs14 rad8 noborder",
              style: {"height":"50px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectAvailableFieldsForAI && _ctx.selectAvailableFieldsForAI(...args)))
            }, [
              _hoisted_2,
              _createVNode(_component_IconHelp, {
                width: 18,
                class: "fl mr10",
                style: `margin-top: 1px;`,
                tooltipText: `AIが利用する質問を設定することで、返答の正確性、スピードが向上します。`
              })
            ])
          ]),
          _hoisted_3,
          (_ctx.Util.isPresent(_ctx.rcm.room.available_field_public_ids))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rcm.room.available_field_public_ids, (ffid, ffindex) => {
                  return (_openBlock(), _createElementBlock("div", { key: ffindex }, [
                    (_ctx.rcm.room.form_fields.find(f => f.public_id == ffid))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.rcm.room.form_fields.find(f => f.public_id == ffid).field_name), 1),
                          (_ctx.rcm.room.form_fields.find(f => f.public_id == ffid).is_special)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.$getAssetImageUrl(`/assets/icons/asta.png`),
                                width: "20",
                                height: "23",
                                class: "pointer fl mr5"
                              }, null, 8, _hoisted_8))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                _hoisted_9
              ]))
            : _createCommentVNode("", true),
          _hoisted_10
        ]),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableScheduleRules, (rule, rulekey) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "w100",
              key: `${rulekey}${rule.id}`
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.alphabets[rulekey]), 1),
                  (rule.astag_info)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_CalendarIcon, {
                          astag: rule.astag_info,
                          width: 40,
                          iconWidth: 40,
                          totalHeight: 40,
                          canDelete: false,
                          hideName: true,
                          hideBorder: true,
                          classes: `fl mt3`,
                          showSharedInfo: false
                        }, null, 8, ["astag"]),
                        _createElementVNode("p", _hoisted_15, "「" + _toDisplayString(_ctx.truncate(rule.astag_info.name, 15)) + "」の調整カレンダー", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18)),
                  _hoisted_19
                ]),
                _createElementVNode("div", null, [
                  (_ctx.rcm.room.is_owner)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "fl borderGrey rad15 centered pointer mt14 hoverLgreyBg with_white_bg mr5",
                        style: {"padding":"2px 8px"},
                        onClick: ($event: any) => (_ctx.clickChangeAstag(rule.id))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/change.png`),
                          width: "19",
                          height: "19",
                          class: "fl mt1 mr2",
                          style: {}
                        }, null, 8, _hoisted_21),
                        _hoisted_22,
                        _hoisted_23
                      ], 8, _hoisted_20))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "fl borderGrey rad15 centered pointer mt14 hoverLgreyBg with_white_bg",
                    style: {"padding":"2px 8px"},
                    onClick: ($event: any) => (_ctx.clickSelectTemplateForAI(rule.id))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/create_event.png`),
                      width: "14",
                      height: "14",
                      class: "fl mt4 mr2",
                      style: {}
                    }, null, 8, _hoisted_25),
                    _hoisted_26,
                    _hoisted_27
                  ], 8, _hoisted_24),
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                    width: "17",
                    height: "21",
                    onClick: ($event: any) => (_ctx.deleteRule(rule)),
                    class: "pointer fr mr5 mt20"
                  }, null, 8, _hoisted_28)
                ]),
                _createVNode(_component_TextareaTag, {
                  placeholder: "○○の場合、このカレンダーを利用してください。",
                  class: "fl fs14 roundForm mw100",
                  value: rule.manual,
                  maxlength: 100,
                  retValue: rule.id,
                  style: {"height":"90px"},
                  onInputValue: _ctx.inputManual
                }, null, 8, ["value", "retValue", "onInputValue"]),
                _createElementVNode("div", _hoisted_29, _toDisplayString(rule.manual ? rule.manual.length : 0) + " / 100", 1),
                _hoisted_30
              ]),
              _hoisted_31
            ]))
          }), 128)),
          _hoisted_32
        ]),
        (_ctx.rcm.room.is_owner)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              (_ctx.availableScheduleRules.length < 5)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "pad15 pointer centered",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addRule && _ctx.addRule(...args)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/round_plus.png`),
                      width: "37",
                      height: "40"
                    }, null, 8, _hoisted_34),
                    _hoisted_35,
                    _hoisted_36
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_40))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43)),
        _hoisted_44
      ]))
    : _createCommentVNode("", true)
}